import { render, staticRenderFns } from "./qklw.vue?vue&type=template&id=3a53517f&scoped=true"
import script from "./qklw.vue?vue&type=script&lang=js"
export * from "./qklw.vue?vue&type=script&lang=js"
import style0 from "./qklw.vue?vue&type=style&index=0&id=3a53517f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a53517f",
  null
  
)

export default component.exports